<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left:20px">
        <FormItem label="展示数据">
          <Tag
            :checked="showColumnTitleArray.indexOf(item.title) > -1"
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
          >{{item.title}}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>
    <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>修改设备信息</span>
      </p>
      <Form :model="updateObject" label-position="left" :label-width="100">
        <FormItem label="用户编号">
          <Input v-model="updateObject.consumerNumber" placeholder="输入用户编号" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="用户姓名">
          <Input v-model="updateObject.consumerName" placeholder="输入用户姓名" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="联系电话">
          <Input v-model="updateObject.consumerPhone" placeholder="输入联系电话" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="备注">
          <Input v-model="updateObject.consumerRemark" placeholder="输入备注" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="行政区">
          <Select v-model="updateObject.addressfield1" style="width:250px" placeholder="选择行政区">
            <Option
              v-for="item in addressObject.addressfield1"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="小区">
          <Select v-model="updateObject.addressfield2" style="width:250px" placeholder="选择小区">
            <Option
              v-for="item in addressObject.addressfield2"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="楼栋">
          <Select v-model="updateObject.addressfield3" style="width:250px" placeholder="选择楼栋">
            <Option
              v-for="item in addressObject.addressfield3"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="单元">
          <Select v-model="updateObject.addressfield4" style="width:250px" placeholder="选择单元">
            <Option
              v-for="item in addressObject.addressfield4"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="门牌">
          <Select v-model="updateObject.addressfield5" style="width:250px" placeholder="选择门牌">
            <Option
              v-for="item in addressObject.addressfield5"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="表具类型">
          <Select disabled v-model="updateObject.meterType" style="width:250px" placeholder="选择表具类型">
            <!-- <Option value="水表" key="水表">水表</Option> -->
            <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="表具地址" placeholder="输入表具地址">
          <Input disabled v-model="updateObject.meterAddress" placeholder="输入表具地址" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="口径" placeholder="输入口径">
          <Input disabled v-model="updateObject.meterCaliber" placeholder="输入口径" style="width: 250px" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="margin-left:10px" type="primary" icon="ios-search" @click="updateMeter">提交更新</Button>
      </div>
    </Modal>
    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <div class="query-c">
        <Row style="white-space:nowrap;">
          <Col
            span="15"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:3%;">
              <br />
              <div>
                <Select
                  clearable
                  filterable
                  placeholder="选择行政区"
                  v-model="addressfield1"
                  style="width:19%;"
                >
                  <Option
                    v-for="item in addressObject.addressfield1"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择小区"
                  v-model="addressfield2"
                  style="width:19%;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield1"
                    v-for="item in addressObject.addressfield2"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择楼栋"
                  v-model="addressfield3"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield2"
                    v-for="item in addressObject.addressfield3"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择单元"
                  v-model="addressfield4"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield3"
                    v-for="item in addressObject.addressfield4"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择门牌"
                  v-model="addressfield5"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield4"
                    v-for="item in addressObject.addressfield5"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </div>
              <div style="margin-top:5px">
                <Input v-model="consumerNumber" style="width:19%" placeholder="输入用户编号" />
                <Input
                  v-model="consumerName"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户姓名"
                />
                <Input
                  v-model="consumerPhone"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户联系电话"
                />
                <Select
                  clearable
                  filterable
                  placeholder="选择客户类型"
                  v-model="addressRemark1"
                  style="width:19%;;margin-left:5px"
                >
                  <Option value="居民用户" key="居民用户">居民用户</Option>
                  <Option value="企业用户" key="企业用户">企业用户</Option>
                </Select>

                <Button
                  style="margin-left:10%;width:9%"
                  type="primary"
                  icon="ios-search"
                  @click="showPage"
                >查询</Button>
              </div>
              <br />
            </div>
          </Col>
          <Col
            span="3"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:15%">
              <br />
              <div>
                <Button style="width:80%" type="primary" @click="downloadTemplete">模板下载</Button>
              </div>
              <div style="margin-top:5px">
                <Button style="width:80%" type="primary" @click="clickImport">表具信息导入</Button>
              </div>
              <Upload
                style="display: none;"
                ref="upload"
                name="file"
                action="/api/excel/importMeterUserNew"
                :on-success="handelResponse"
                :format="['xlsx','xls']"
                :show-upload-list="false"
              >
                <input id="upload_file_meter" />
              </Upload>
              <br />
            </div>
          </Col>
          <Col span="5" style="margin-left:35px">
            <br />
            <Button
              type="primary"
              @click="isShowSetModal = true"
              style="margin-left: 20px;float:right;width: 102px"
            >显示项设置</Button>
          </Col>
          <Col span="5" style="margin-left:35px">
            <Button
              type="primary"
              style="margin-left: 20px;margin-top: 5px; float:right;width: 102px"
              @click="exportData()"
            >数据导出</Button>
          </Col>
        </Row>
        <!-- <Select filterable placeholder="选择设备地址" v-model="meterAddress" style="width:150px;;margin-left:5px">
          <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
        </Select>-->
      </div>
      <Table
        ref="table"
        style="margin-top:5px"
        size="small"
        :height="tableHeight"
        border
        stripe
        :columns="columns"
        :data="data"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="isShowStateModal = true;updateObject = row"
          >修改</Button>
        </template>
        <template slot-scope="{ row, index }" slot="del">
          <Button type="primary" size="small" style="margin-right: 5px" @click="delMeter(row)">删除</Button>
        </template>
      </Table>
      <br />
      <!-- <Page :total="100" show-sizer show-elevator /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "meter",
  data() {
    return {
      meterTypeEnum: global.meterType(),
      showColumnTitleArray: [],
      columnsbackup: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "consumerNumber",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "联系电话",
          key: "consumerPhone",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '行政区',
          key: 'addressfield1Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '小区',
          key: 'addressfield2Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '楼栋',
          key: 'addressfield3Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '单元',
          key: 'addressfield4Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '门牌',
          key: 'addressfield5Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "表具类型",
          width: 160,
          key: "meterType"
        },
        {
          title: "表具地址",
          width: 160,
          key: "meterAddress"
        },
        {
          title: "口径",
          width: 160,
          key: "meterCaliber"
        },
        {
          title: "备注",
          key: "consumerRemark",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "修改",
          slot: "action",
          width: 120,
          align: "center"
        },
        {
          title: "删除",
          slot: "del",
          width: 120,
          align: "center"
        }

        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      addressRemark1: "",
      tableHeight: "200",
      addressfield1: "",
      addressfield2: "",
      addressfield3: "",
      addressfield4: "",
      addressfield5: "",
      consumerNumber: "",
      consumerName: "",
      consumerPhone: "",
      // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
      //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
      //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
      //   "00000018005405", "00000018005456", "00000018005462"
      // ],
      meterArray: [],
      meterArray1: [
        "00000018003155",
        "00000018004361",
        "00000018004457",
        "00000018004523",
        "00000018004798",
        "00000018005064",
        "00000018005332",
        "00000018005401",
        "00000018005456",
        "00000018005462",
        "11110000000000"
      ],
      meterArray2: ["00000018005405", "00000018004345", "00000018004799"],
      addressObject: {},
      stateContrast: global.stateContrast,
      meterAddress: "",
      stateArray: {},
      updateObject: {},
      isShowStateModal: false,
      isShowSetModal: false,
      columns: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "consumerNumber",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "联系电话",
          key: "consumerPhone",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '行政区',
          key: 'addressfield1Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '小区',
          key: 'addressfield2Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '楼栋',
          key: 'addressfield3Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '单元',
          key: 'addressfield4Name',
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: '门牌',
          key: 'addressfield5Name',
          resizable: true,
          show: false,
          width: 160
        },
        
        {
          title: "表具类型",
          width: 160,
          key: "meterType"
        },
        {
          title: "表具地址",
          width: 160,
          key: "meterAddress"
        },
        {
          title: "口径",
          key: "address",
          width: 160,
          key: "meterCaliber"
        },
        {
          title: "备注",
          key: "consumerRemark",
          resizable: true,
          show: false,
          width: 160
        },
        {
          title: "修改",
          slot: "action",
          width: 120,
          align: "center"
        },
        {
          title: "删除",
          slot: "del",
          width: 120,
          align: "center"
        }

        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      data: []
    };
  },
  methods: {
    exportData() {
      // this.$refs.table.exportCsv({
      //                 filename: 'The original data'
      //             });
      this.$refs.table.exportCsv({
        filename: "设备管理数据导出",
        columns: this.columns.filter(
          (col, index) =>
            col.title.indexOf("修改") == -1 && col.title.indexOf("删除") == -1
        ),
        data: this.data.filter((data, index) => index > -1)
      });
    },
    delMeter(row) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要删除该设备？</p>",
        onOk: () => {
          row.delType = 0;
          that.$axios
            .post("/api/meter/delMeter", row)
            .then(data => {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }

              that.$Notice.success({
                title: "提示",
                desc: "删除成功"
              });
              return;
            })
            .catch(error => {
              that.$Notice.error({
                title: "异常",
                desc: error
              });
              console.log(error);
            })
            .finally(() => {
              that.showPage();
            });
        },
        onCancel: () => {}
      });
    },
    clickImport() {
      $("#upload_file_meter").click();
    },
    handelResponse(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      if (response.errorCode != 0) {
        this.$Notice.error({
          title: "导入失败",
          desc: response.errorInfo,
          duration: 0
        });
      } else {
        let result = response.body.exsitAddressList;
        let result2 = response.body.noexsitList;
        let insert = response.body.insertList;
        let count = " 共计导入" + insert.length + "条数据。";
        let indexs = "";
        if (result.length > 0) {
          result.map(item => {
            indexs =
              indexs == ""
                ? item.meterAddress
                : indexs + "," + item.meterAddress;
          });
        }
        let msg =
          indexs == "" ? "" : " 表具地址为" + indexs + "已存在,不予导入。";
        let indexs2 = "";
        if (result2.length > 0) {
          result2.map(item => {
            indexs2 =
              indexs2 == ""
                ? item.meterAddress
                : indexs2 + "," + item.meterAddress;
          });
        }
        let msg2 =
          indexs2 == ""
            ? ""
            : " 表具地址为" + indexs2 + "不存在出厂数据,不予导入。";
        this.$Notice.success({
          title: "成功",
          desc: "导入成功！" + msg + msg2 + count,
          duration: 0
        });
        this.generateColumnTitleArray();
        this.getMeterArray();
        this.getAddressEnum();
      }
    },
    downloadTemplete() {
      window.location.href =
        "/api/excel/downloadLocal?fileUrl=" + "表具模板.xls";
      // try {
      //   var json2csv = require('json2csv');
      //   let fileName = "表具模板";
      //   const result = json2csv.parse([], {
      //     fields: ["用户编号", "用户姓名", "联系电话", "备注", "行政区", "小区", "楼栋", "单元", "门牌", "表具类型", "表具地址", "口径","用户类型（居民用户/企业用户）"],
      //     excelStrings: true
      //   });
      //   if (this.MyBrowserIsIE()) {
      //     // IE10以及Edge浏览器
      //     var BOM = "\uFEFF";
      //     // 文件转Blob格式
      //     var csvData = new Blob([BOM + result], {
      //       type: "text/csv"
      //     });
      //     navigator.msSaveBlob(csvData, `${fileName}.csv`);
      //   } else {
      //     let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      //     // 非ie 浏览器
      //     this.createDownLoadClick(csvContent, `${fileName}.csv`);
      //   }
      // } catch (err) {
      //   alert(err);
      // }
    },
    //创建a标签下载
    createDownLoadClick(content, fileName) {
      const link = document.createElement("a");
      link.href = encodeURI(content);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, // 判断是否IE浏览器
    MyBrowserIsIE() {
      let isIE = false;
      if (
        navigator.userAgent.indexOf("compatible") > -1 &&
        navigator.userAgent.indexOf("MSIE") > -1
      ) {
        // ie浏览器
        isIE = true;
      }
      if (navigator.userAgent.indexOf("Trident") > -1) {
        // edge 浏览器
        isIE = true;
      }
      return isIE;
    },
    updateMeter() {
      var that = this;
      that.updateObject.consumerPhone = that.updateObject.consumerPhone.replace("\t", "");
      that.updateObject.meterAddress = that.updateObject.meterAddress.replace("\t", "");
      that.$axios
        .post("/api/meter/updateMeter", that.updateObject)
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.$Modal.success({
            title: "提示",
            content: "修改成功"
          });

          that.showPage();
          that.isShowStateModal = false;
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;
    },
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressObject = data.body;
          that.addressObject.addressfield5.sort(function(a, b) {
            return (
              a.name.replace("号", "").replace("-", "") -
              b.name.replace("号", "").replace("-", "")
            );
          });
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    parseDate(str) {
      var year = str.substr(0, 4);
      var month = str.substr(4, 2);
      var day = str.substr(6, 2);
      var hour = str.substr(8, 2);
      var minute = str.substr(10, 2);
      var second = str.substr(12, 2);
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    onClickSearch() {
      this.showPage();
    },
    showState(row) {
      this.isShowStateModal = true;
      this.stateArray = JSON.parse(row.messageContent).decode.state;
    },
    showStateStr(row) {
      let stateArray = JSON.parse(row.messageContent).decode.state;
      let that = this;
      let stateStr = "";
      Object.keys(stateArray).forEach(function(key) {
        if (stateArray[key] == that.stateContrast[key]) {
          stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
        }
      });

      return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
    },
    changeColumn(checked, name) {
      if (checked) {
        this.showColumnTitleArray.push(name);
      } else {
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName + localStorage.getItem("userAccount"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;
    },
    showPage() {
      var that = this;
      that.data = [];
      that.$axios
        .post("/api/meter/selectMeter", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5,
          addressRemark1: that.addressRemark1,
          consumerNumber: that.consumerNumber,
          consumerName: that.consumerName,
          consumerPhone: that.consumerPhone
        })
        .then(function(res) {
          console.log(res);

          let currentArray = [];
          currentArray = res.body;
          console.log(currentArray);

          that.data = currentArray;
          for (let i = 0; i < that.data.length; i++) {
            that.data[i].consumerPhone = that.data[i].consumerPhone + "\t";
            that.data[i].meterAddress = that.data[i].meterAddress + "\t";
          }
          that.data.sort(function(a, b) {
            return b.consumerNumber - a.consumerNumber;
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async getMeterArray() {
      var that = this;
      that.$axios
        .post("/api/meter/selectMeterList", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterArray = data.body;

          // that.showPage();
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    }
  },
  mounted() {
    // this.showPage();
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.8;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.8;

    that.generateColumnTitleArray();
    that.getMeterArray();
    that.getAddressEnum();
  }
};
</script>

<style scoped>
</style>
